import { defaultVertexShader } from '.'

const wavyFragmentShader = `
    precision mediump float;
    
    varying vec2 v_texcoord;
    
    uniform float u_intensity;
    uniform float u_progress;
    uniform sampler2D u_texture;

    void main() {
        float frequency = 8.0;
        float amplitude = 0.05 * u_intensity + 0.01;
        float time = radians(u_progress * 360.0);
        
        vec2 pulse = sin(time - frequency * v_texcoord);
        float dist = 2.0 * length(v_texcoord.y - 0.5);
        
        vec2 newCoord = v_texcoord + amplitude * vec2(0.0, pulse.x);
        
        vec2 interpCoord = mix(newCoord, v_texcoord, dist);
        
        gl_FragColor = texture2D(u_texture, interpCoord);
    }
`

export const wavyShaderSource = {
    fragment: wavyFragmentShader,
    vertex: defaultVertexShader,
}
